import styled from 'styled-components';
import { paragraph1, paragraph2 } from '../../tokens';
import { applyHyphens, applySpacing } from '../../mixins';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Typography/Paragraph');
export var ParagraphText1 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-137f45k-0"
})(["", " ", " ", ""], applyHyphens, applySpacing, paragraph1);
export var ParagraphText2 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-137f45k-1"
})(["", " ", " ", ""], applyHyphens, applySpacing, paragraph2);
export var P1 = /*#__PURE__*/styled.p.withConfig({
  componentId: "plasma__sc-137f45k-2"
})(["", " ", " ", " margin:0;"], applyHyphens, applySpacing, paragraph1);
export var P = P1;
export var P2 = /*#__PURE__*/styled.p.withConfig({
  componentId: "plasma__sc-137f45k-3"
})(["", " ", " ", " margin:0;"], applyHyphens, applySpacing, paragraph2);